import React from 'react';
import InputForm from '../../../../../components/form/InputForm';
import Panel from '../../../../../components/outline/Panel';
import RadioGroupForm from '../../../../../components/form/RadioGroupForm';
import {
  MAXIMUM_NUMBER_OF_TAG_GROUP_NAME,
  TAG_GROUP_TYPE_SELECT_LIST,
} from '../../../../../constants/service/app/tagConstants';
import { formRequiredRules } from '../../../../../lib/formRules';
import { REQUIRED_MSG } from '../../../../../constants/service/common/formRulesConstants';
import './TagGroupEditInfo.scss';

const TagGroupEditInfo = (props) => {
  const { form, tagGroupInfo, onChangeTagGroupName, setData } = props;

  return (
    <Panel className="tag-group-edit-info">
      <div className="panel-header">
        <div className="title">태그 그룹(분류)정보</div>
      </div>

      <div className="panel-body">
        {/* 태그 그룹명*/}
        <InputForm
          label="태그 그룹명"
          form={form}
          className="tag-group-name"
          rules={[formRequiredRules(true, REQUIRED_MSG)]}
          initialValue={tagGroupInfo.tagGroupName}
          maxLength={MAXIMUM_NUMBER_OF_TAG_GROUP_NAME}
          onChange={(value) => onChangeTagGroupName(value)}
          name="tagName"
          subContent={
            <div className="sub-info">
              {tagGroupInfo.isDuplicationTagGroupName ? (
                <div className="input-warning">이미 등록된 태그 그룹명입니다.</div>
              ) : null}
              <div>*태그 그룹명은 최대 13자리까지 입력 가능합니다.</div>
            </div>
          }
        />

        {/*태그 그룹 타입*/}
        <RadioGroupForm
          className="tag-group-type"
          form={form}
          label="태그 그룹 타입"
          name="tagGroupType"
          list={TAG_GROUP_TYPE_SELECT_LIST}
          initialValue={tagGroupInfo.tagGroupType}
          onChange={(value) =>
            setData({
              path: ['tagGroupType'],
              value,
            })
          }
          size="large"
        />
      </div>
    </Panel>
  );
};

export default TagGroupEditInfo;
